var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "section-post-creator",
      class: [
        _vm.mode,
        {
          "conciergerie-edit":
            _vm.mode === "update" && _vm.isFacebookConciergerieEdit,
        },
      ],
    },
    [
      _c("header", [
        _c("div", { staticClass: "container-title" }, [
          _c("div", {
            staticClass: "btn-back",
            on: {
              click: function ($event) {
                return _vm.$router.push("/dash/posts2")
              },
            },
          }),
          _c("div", { staticClass: "text" }, [
            _c("h2", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
            !_vm.previewMode.active &&
            ["create", "duplicate"].includes(_vm.mode) &&
            _vm.canRestoreDraft
              ? _c(
                  "p",
                  {
                    staticClass: "switchOldVersion",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("retoreDraftInLocalStorage")
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("dash.post-creator.action.restore-draft"))
                    ),
                  ]
                )
              : _vm.mode !== "create"
              ? _c(
                  "p",
                  {
                    staticClass: "switchOldVersion",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/dash/posts2")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("dash.post-creator.back-to-planner")))]
                )
              : _vm._e(),
          ]),
        ]),
        !_vm.previewMode.active && _vm.switchModeShow
          ? _c(
              "div",
              { staticClass: "custom-edtion-mode" },
              [
                _c(
                  "h5",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.handleChangecustomMode()
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("dash.post-creator.custom-mode.title"))
                    ),
                  ]
                ),
                _c("ComponentSwitch", {
                  attrs: {
                    value: _vm.draftInstance.form.merge.target !== "main",
                    onChange: (value) => _vm.handleChangecustomMode(value),
                    id: "switchEditionMode",
                  },
                }),
                _c(
                  "p",
                  {
                    staticClass: "state-edition-mode",
                    on: {
                      click: function ($event) {
                        return _vm.handleChangecustomMode()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.draftInstance.form.merge.target == "main"
                            ? _vm.$t("dash.post-creator.custom-mode.disabled")
                            : _vm.$t("dash.post-creator.custom-mode.enabled")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm.draftInstance.form.merge.target == "main" &&
                _vm.showTutorial
                  ? _c("div", { staticClass: "tutorial" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "29",
                            height: "31",
                            viewBox: "0 0 29 31",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M7.61478 29.4303C3.46662 10.3949 6.9428 1.2045 27.9404 0.99937M7.61478 29.4303L1.21998 23.77M7.61478 29.4303L12.2981 22.1357",
                              stroke: "#B64985",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("dash.post-creator.custom-mode.hint")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "btns-action" },
          [
            _vm.previewMode.active
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "btn-outline-primary",
                      on: {
                        click: () => _vm.handlerChangePreviewDisplay(false),
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("dash.button.go_back")))]
                  ),
                  !_vm.isFileUploading
                    ? _c(
                        "div",
                        {
                          staticClass: "btn-secondary icon-r",
                          on: { click: _vm.sendPostAllPost },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.textBtnFinish || "Error") +
                              "\n          "
                          ),
                          _c("i", { staticClass: "fa-solid fa-arrow-right" }),
                        ]
                      )
                    : _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.$t("dash.post-creator.media.uploading"),
                            active: _vm.isFileUploading,
                            classCustom: "btn-secondary icon-r disable",
                            position: "bottom",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.textSwitchPreview) +
                              "\n          "
                          ),
                          _c("i", { staticClass: "fa-solid fa-arrow-right" }),
                        ]
                      ),
                ]
              : [
                  _vm.mode !== "update" &&
                  _vm.draftInstance.form.planifiedDate.date
                    ? [
                        _vm.draftInstance.usersAssigned.includes(
                          _vm.currentUser.id
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "btn assign",
                                on: { click: _vm.unassignCurrentUser },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("dash.post-creator.user.unassign")
                                    ) +
                                    "\n            "
                                ),
                                _c("i", {
                                  staticClass: "fa-solid fa-user-minus",
                                }),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "btn assign",
                                on: { click: _vm.assignUsers },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("dash.post-creator.user.assign")
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.draftInstance.usersAssigned.length
                                        ? `(${_vm.draftInstance.usersAssigned.length})`
                                        : ""
                                    ) +
                                    "\n            "
                                ),
                                _c("i", {
                                  staticClass: "fa-solid fa-user-plus",
                                }),
                              ]
                            ),
                      ]
                    : _vm._e(),
                  _c(
                    "Tooltip",
                    {
                      attrs: {
                        text: _vm.$t("dash.post-creator.media.uploading"),
                        active: false && _vm.isFileUploading,
                        position: "bottom",
                      },
                    },
                    [
                      _vm.mode !== "update" &&
                      !(
                        _vm.draftInstance.form.planifiedDate.date &&
                        _vm.draftInstance.usersAssigned.length &&
                        _vm.draftInstance.usersAssigned.requiredValidation
                      )
                        ? _c(
                            "div",
                            {
                              staticClass: "btn-outline-primary",
                              class: { disable: false && _vm.isFileUploading },
                              on: { click: _vm.saveDraft },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    {
                                      create: _vm.$t(
                                        "dash.post-creator.action.save-draft"
                                      ),
                                      duplicate: _vm.$t(
                                        "dash.post-creator.action.save-draft"
                                      ),
                                      edit: _vm.$t(
                                        "dash.post-creator.action.convert-to-draft"
                                      ),
                                      draft: _vm.$t(
                                        "dash.post-creator.action.save"
                                      ),
                                    }[_vm.mode || "create"]
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "Tooltip",
                    {
                      attrs: {
                        text: _vm.$t("dash.post-creator.media.uploading"),
                        active: _vm.isFileUploading,
                        position: "bottom",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn-secondary icon-r",
                          class: { disable: _vm.isFileUploading },
                          on: {
                            click: () => _vm.handlerChangePreviewDisplay(true),
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.textSwitchPreview) +
                              "\n            "
                          ),
                          _c("i", { staticClass: "fa-solid fa-arrow-right" }),
                        ]
                      ),
                    ]
                  ),
                ],
          ],
          2
        ),
      ]),
      _c(
        "div",
        { ref: "postCreator", class: "post-creator " + _vm.formShow },
        [
          _vm.formShow == "formMultiple"
            ? _c("div", { staticClass: "container-form" }, [
                _c("div", { staticClass: "nav-type-post" }, [
                  _vm._m(0),
                  _vm.draftInstance.form.networks.instagram.storification
                    .pagesActived.length
                    ? _c(
                        "div",
                        {
                          staticClass: "icon-l",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return (() =>
                                _vm.$emit("toogleStorificationTab")).apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-solid fa-share-from-square",
                          }),
                          _vm._v("\n          Partage en story\n        "),
                        ]
                      )
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  { staticClass: "container-form-scroll hide-scrollbar" },
                  [
                    _c(
                      "div",
                      { staticClass: "form" },
                      [
                        _c("div", { staticClass: "list-pages-selected" }, [
                          _vm.mode !== "update"
                            ? _c(
                                "div",
                                {
                                  staticClass: "btn-add-page",
                                  class: { retract: _vm.pagesSelected.length },
                                  on: { click: _vm.openSelectPage },
                                },
                                [
                                  _c("i", { staticClass: "fa-solid fa-plus" }),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.post-creator.pages.add")
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass:
                                "container-list-avatars hide-scrollbar",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "list-avatars hide-scrollbar" },
                                _vm._l(
                                  _vm.draftInstance.pages.items,
                                  function (page) {
                                    return _c(
                                      "Tooltip",
                                      {
                                        key: page.id,
                                        attrs: { text: page.name },
                                      },
                                      [
                                        _c(
                                          "ContextMenu",
                                          {
                                            attrs: {
                                              options: _vm.customModeIsAvailable
                                                ? [
                                                    {
                                                      label: "Retirer la page",
                                                      name: "removePage",
                                                    },
                                                    {
                                                      label:
                                                        "Personnaliser la page",
                                                      name: "customPage",
                                                    },
                                                  ]
                                                : [
                                                    {
                                                      label: "Retirer la page",
                                                      name: "removePage",
                                                    },
                                                  ],
                                              id: "contextMenuPage" + page.id,
                                            },
                                            on: {
                                              clickOption: (_, name) =>
                                                _vm.clickContextMenuPage(
                                                  name,
                                                  page
                                                ),
                                            },
                                          },
                                          [
                                            _c("Avatar", {
                                              attrs: {
                                                urlPicture: page.avatar,
                                                typeNetwork: page.network,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          ),
                        ]),
                        _c("Form", {
                          attrs: {
                            files: _vm.files,
                            typeRenderNetworkSelected: _vm.typeNetworkSelected,
                            formData: _vm.formData,
                            networksSelected: _vm.networksSelected,
                            draftInstance: _vm.draftInstance,
                          },
                          on: {
                            setSelectTypeRenderNetwork: _vm.selectTypeNetwork,
                            addFile: (...args) =>
                              this.$emit("addFile", ...args),
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { ref: "containerPhone", staticClass: "container-phone" },
            [
              _vm.draftInstance.form.merge.target == "main"
                ? _c("div", { staticClass: "nav-type-network" }, [
                    _c(
                      "div",
                      { staticClass: "list-network" },
                      [
                        _vm._l(_vm.listNetworkSort, function (networkName) {
                          return [
                            _vm.networksSelected.includes(networkName)
                              ? _c(
                                  "Tooltip",
                                  {
                                    key: networkName,
                                    attrs: {
                                      text:
                                        _vm.mode == "update" &&
                                        !_vm.editableNetworks.includes(
                                          networkName
                                        )
                                          ? _vm.$t(
                                              "dash.post-creator.error.network-edit-impossible"
                                            )
                                          : _vm.draftInstance.form.networks[
                                              networkName
                                            ].validator.error,
                                      active:
                                        (_vm.mode == "update" &&
                                          !_vm.editableNetworks.includes(
                                            networkName
                                          )) ||
                                        !_vm.draftInstance.form.networks[
                                          networkName
                                        ].validator.isValid,
                                      position: "left",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "network",
                                        class: {
                                          active:
                                            _vm.typeNetworkSelected ==
                                            networkName,
                                          disable:
                                            !_vm.draftInstance.form.networks[
                                              networkName
                                            ].validator.isValid,
                                          [networkName]: true,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectTypeNetwork(
                                              networkName
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.draftInstance.form.merge
                                          .saveAllFormData.networks[networkName]
                                          ? _c("Tooltip", {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.post-creator.custommode.see-changes"
                                                ),
                                                position: "right",
                                                classCustom: `icon-edited`,
                                              },
                                              on: {
                                                click: () => {
                                                  _vm.handleChangecustomMode(
                                                    true,
                                                    networkName
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        networkName == "bluesky"
                                          ? _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  viewBox: "0 0 640 640",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M439.8 358.7C436.5 358.3 433.1 357.9 429.8 357.4C433.2 357.8 436.5 358.3 439.8 358.7zM320 291.1C293.9 240.4 222.9 145.9 156.9 99.3C93.6 54.6 69.5 62.3 53.6 69.5C35.3 77.8 32 105.9 32 122.4C32 138.9 41.1 258 47 277.9C66.5 343.6 136.1 365.8 200.2 358.6C203.5 358.1 206.8 357.7 210.2 357.2C206.9 357.7 203.6 358.2 200.2 358.6C106.3 372.6 22.9 406.8 132.3 528.5C252.6 653.1 297.1 501.8 320 425.1C342.9 501.8 369.2 647.6 505.6 528.5C608 425.1 533.7 372.5 439.8 358.6C436.5 358.2 433.1 357.8 429.8 357.3C433.2 357.7 436.5 358.2 439.8 358.6C503.9 365.7 573.4 343.5 593 277.9C598.9 258 608 139 608 122.4C608 105.8 604.7 77.7 586.4 69.5C570.6 62.4 546.4 54.6 483.2 99.3C417.1 145.9 346.1 240.4 320 291.1z",
                                                  },
                                                }),
                                              ]
                                            )
                                          : networkName == "threads"
                                          ? _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  viewBox: "0 0 192 192",
                                                  width: "100%",
                                                  height: "100%",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z",
                                                  },
                                                }),
                                              ]
                                            )
                                          : networkName == "twitter"
                                          ? _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  viewBox: "0 0 300 271",
                                                  width: "100%",
                                                  height: "100%",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z",
                                                  },
                                                }),
                                              ]
                                            )
                                          : networkName == "linkedin"
                                          ? _c("i", {
                                              staticClass:
                                                "fa-brands fa-linkedin-in",
                                            })
                                          : _c("i", {
                                              class: `fa-brands fa-${networkName}`,
                                            }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm.previewMode.active &&
              _vm.previewMode.pageSelected &&
              _vm.previewMode.pageSelected.network == "instagram" &&
              _vm.pagesInstagramActivedShareStory.some(
                (page) => page.id == _vm.previewMode.pageSelected.id
              )
                ? _c("div", { staticClass: "switch-preview-post-type" }, [
                    _c("div", { staticClass: "btn-primary" }, [
                      _vm._v("Standard"),
                    ]),
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return (() =>
                              _vm.$emit("changeTab", "story_share")).apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v("Story")]
                    ),
                  ])
                : _vm._e(),
              _c(
                "Phone",
                { attrs: { firstPlan: _vm.phoneIsFirstPlan } },
                [
                  _vm.textPostFailed
                    ? _c("renderPostFailed", {
                        attrs: { textError: _vm.textPostFailed },
                      })
                    : _vm._e(),
                  _c("renderPostManager", {
                    attrs: {
                      typeNetworkSelected:
                        _vm.draftInstance.form.merge.target == "main"
                          ? _vm.typeNetworkSelected
                          : _vm.draftInstance.form.merge.target.network ||
                            _vm.draftInstance.form.merge.target,
                      formData: _vm.formData,
                      draft: _vm.draftInstance,
                      files: _vm.files,
                      pages: _vm.pageForRenderPost,
                      idsPagesStatusEdited:
                        _vm.pageForRenderPost.length > 1
                          ? _vm.idsPagesEditedForRenderPost
                          : [],
                      positionFormOverlay:
                        _vm.draftInstance.form.merge.target == "main"
                          ? "left"
                          : "right",
                      modes: _vm.modes,
                    },
                    on: { clickPageInRenderPost: _vm.clickPageInRenderPost },
                  }),
                  _vm.modes.includes("addMentionMode")
                    ? _c("selectMention", {
                        attrs: {
                          position:
                            _vm.draftInstance.form.merge.target == "main"
                              ? "left"
                              : "right",
                          mentionData:
                            _vm.dataMode.addMentionMode &&
                            _vm.dataMode.addMentionMode.mention
                              ? _vm.dataMode.addMentionMode.mention
                              : {},
                          idMention:
                            _vm.dataMode.addMentionMode &&
                            _vm.dataMode.addMentionMode.idMention
                              ? _vm.dataMode.addMentionMode.idMention
                              : null,
                          networks:
                            _vm.dataMode.addMentionMode &&
                            _vm.dataMode.addMentionMode.networks
                              ? _vm.dataMode.addMentionMode.networks
                              : null,
                          text:
                            _vm.dataMode.addMentionMode &&
                            _vm.dataMode.addMentionMode.text
                              ? _vm.dataMode.addMentionMode.text
                              : null,
                          mentions: _vm.formData.mentions,
                          close:
                            _vm.dataMode.addMentionMode &&
                            _vm.dataMode.addMentionMode.close
                              ? _vm.dataMode.addMentionMode.close
                              : null,
                          searchMention:
                            _vm.dataMode.addMentionMode &&
                            _vm.dataMode.addMentionMode.searchMention
                              ? _vm.dataMode.addMentionMode.searchMention
                              : null,
                          removeMention:
                            _vm.dataMode.addMentionMode &&
                            _vm.dataMode.addMentionMode.removeMention
                              ? _vm.dataMode.addMentionMode.removeMention
                              : null,
                          addMention:
                            _vm.dataMode.addMentionMode &&
                            _vm.dataMode.addMentionMode.addMention
                              ? _vm.dataMode.addMentionMode.addMention
                              : null,
                        },
                        on: { close: _vm.removeMode },
                      })
                    : _vm._e(),
                  _vm.modes.includes("addHashtagMode")
                    ? _c("selectHashtag", {
                        attrs: {
                          position:
                            _vm.draftInstance.form.merge.target == "main"
                              ? "left"
                              : "right",
                          id:
                            _vm.dataMode.addHashtagMode &&
                            _vm.dataMode.addHashtagMode.id
                              ? _vm.dataMode.addHashtagMode.id
                              : "",
                          searchHashtags:
                            _vm.dataMode.addHashtagMode &&
                            _vm.dataMode.addHashtagMode.searchHashtags
                              ? _vm.dataMode.addHashtagMode.searchHashtags
                              : null,
                          apply:
                            _vm.dataMode.addHashtagMode &&
                            _vm.dataMode.addHashtagMode.apply
                              ? _vm.dataMode.addHashtagMode.apply
                              : null,
                        },
                        on: { close: _vm.removeMode },
                      })
                    : _vm._e(),
                  _vm.modes.includes("inputMode")
                    ? _c(
                        "inputOverlay",
                        _vm._b(
                          {
                            attrs: {
                              position:
                                _vm.draftInstance.form.merge.target == "main"
                                  ? "left"
                                  : "right",
                            },
                            on: { close: _vm.removeMode },
                          },
                          "inputOverlay",
                          _vm.dataMode.inputMode,
                          false
                        )
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.previewMode.active
                ? _c("div", { staticClass: "nav-page-standard" }, [
                    _c(
                      "div",
                      { staticClass: "list-page hide-scrollbar" },
                      [
                        _vm._l(
                          _vm.draftInstance.pages.networksSelected,
                          function (networkName, index) {
                            return [
                              _c(
                                "div",
                                { key: networkName, staticClass: "group" },
                                [
                                  _c("div", {
                                    staticClass: "network",
                                    class: {
                                      [networkName]: true,
                                      failed: _vm.draftInstance.pages.some(
                                        (page) =>
                                          page.network == networkName &&
                                          _vm.requests &&
                                          _vm.requests.posts &&
                                          _vm.requests.posts[page.id] &&
                                          _vm.requests.posts[page.id].message
                                      ),
                                    },
                                    on: {
                                      click: () => {
                                        _vm.$emit(
                                          "changePreviewDisplay",
                                          true,
                                          _vm.draftInstance.pages
                                            .pagesByNetwork[networkName][0]
                                        )
                                        _vm.draftInstance.form.merge.run(
                                          _vm.draftInstance.pages
                                            .pagesByNetwork[networkName][0]
                                        )
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "list-avatar" },
                                    _vm._l(
                                      _vm.draftInstance.pages.pagesByNetwork[
                                        networkName
                                      ],
                                      function (page) {
                                        return _c(
                                          "div",
                                          {
                                            key: page.id,
                                            staticClass: "container-avatar",
                                            class: {
                                              checked:
                                                _vm.previewMode.pageSelected &&
                                                _vm.previewMode.pageSelected
                                                  .id == page.id,
                                              failed:
                                                _vm.requests &&
                                                _vm.requests.posts &&
                                                _vm.requests.posts[page.id] &&
                                                _vm.requests.posts[page.id]
                                                  .message,
                                            },
                                          },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: page.name,
                                                  active: true,
                                                  position: "right",
                                                },
                                              },
                                              [
                                                _c("Avatar", {
                                                  attrs: {
                                                    checkIsPossible: true,
                                                    checked:
                                                      _vm.previewMode
                                                        .pageSelected &&
                                                      _vm.previewMode
                                                        .pageSelected.id ==
                                                        page.id,
                                                    urlPicture: page.avatar,
                                                  },
                                                  on: {
                                                    click: () => {
                                                      _vm.$emit(
                                                        "changePreviewDisplay",
                                                        true,
                                                        page
                                                      )
                                                      _vm.draftInstance.form.merge.run(
                                                        page
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          }
                        ),
                      ],
                      2
                    ),
                  ])
                : _c("div", { staticClass: "nav-page-standard" }, [
                    _c(
                      "div",
                      { staticClass: "list-page hide-scrollbar" },
                      [
                        _vm._l(
                          _vm.draftInstance.pages.networksSelected,
                          function (networkName, index) {
                            return [
                              _c(
                                "div",
                                {
                                  key: networkName,
                                  staticClass: "group",
                                  class: {
                                    active:
                                      _vm.draftInstance.form.merge.target ==
                                      networkName,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "network",
                                      class: {
                                        [networkName]: true,
                                        edited:
                                          _vm.saveAllFormData.networks[
                                            networkName
                                          ] &&
                                          Object.keys(
                                            _vm.saveAllFormData.networks[
                                              networkName
                                            ]
                                          ).length > 0,
                                        failed:
                                          _vm.previewMode.active &&
                                          _vm.pagesSelected.some(
                                            (page) =>
                                              page.network == networkName &&
                                              _vm.dataFormRequest[page.id] &&
                                              _vm.dataFormRequest[page.id].error
                                          ),
                                      },
                                      on: {
                                        click: () =>
                                          _vm.draftInstance.form.merge.run(
                                            networkName
                                          ),
                                      },
                                    },
                                    [
                                      _vm.draftInstance.form.merge.target !==
                                      networkName
                                        ? _c("Checkbox", {
                                            attrs: {
                                              isChecked:
                                                _vm.draftInstance.form.merge
                                                  .target == networkName,
                                              add: _vm.draftInstance.form.merge
                                                .run,
                                              isDisable:
                                                _vm.draftInstance.form.merge
                                                  .target == networkName,
                                              prefexId:
                                                "networkcustomModePostCreator" +
                                                index,
                                              id: networkName,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "list-avatar" },
                                    _vm._l(
                                      _vm.draftInstance.pages.pagesByNetwork[
                                        networkName
                                      ],
                                      function (page) {
                                        return _c(
                                          "div",
                                          {
                                            key: page.id,
                                            staticClass: "container-avatar",
                                            class: {
                                              checked:
                                                (_vm.draftInstance.form.merge
                                                  .target.id &&
                                                  _vm.draftInstance.form.merge
                                                    .target.id == page.id) ||
                                                _vm.draftInstance.form.merge
                                                  .target == networkName,
                                              edited:
                                                _vm.draftInstance.form.merge
                                                  .saveAllFormData.pages[
                                                  page.id
                                                ],
                                            },
                                          },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: page.name,
                                                  active: true,
                                                  position: "right",
                                                },
                                              },
                                              [
                                                _c("Avatar", {
                                                  attrs: {
                                                    checkIsPossible: true,
                                                    checked:
                                                      (_vm.draftInstance.form
                                                        .merge.target.id &&
                                                        _vm.draftInstance.form
                                                          .merge.target.id ==
                                                          page.id) ||
                                                      _vm.draftInstance.form
                                                        .merge.target ==
                                                        networkName,
                                                    urlPicture: page.avatar,
                                                  },
                                                  on: {
                                                    click: () =>
                                                      _vm.draftInstance.form.merge.run(
                                                        page
                                                      ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
            ],
            1
          ),
          _vm.formShow == "formUnique"
            ? [
                _c("div", { staticClass: "container-form" }, [
                  _c(
                    "div",
                    {
                      staticClass: "container-form-scroll hide-scrollbar",
                      staticStyle: { "align-items": "flex-end" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form" },
                        [
                          _c("Form", {
                            attrs: {
                              typeRenderNetworkSelected: _vm.draftInstance.form
                                .merge.target.id
                                ? _vm.draftInstance.form.merge.target.network
                                : _vm.draftInstance.form.merge.target,
                              idPageRenderNetworkSelected:
                                _vm.draftInstance.form.merge.target.id,
                              formData: _vm.formData,
                              files: _vm.files,
                              personalizationMode: true,
                              networksSelected: _vm.networksSelected,
                              draftInstance: _vm.draftInstance,
                            },
                            on: {
                              addFile: (...args) =>
                                this.$emit("addFile", ...args),
                              setSelectTypeRenderNetwork: _vm.selectTypeNetwork,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _c("div"),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-l btn-primary" }, [
      _c("i", { staticClass: "fa-solid fa-pen-to-square" }),
      _vm._v("Standard"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }